import React, { Component, PropTypes } from 'react';

export default class BookingAdditionalPlantItem extends Component {
    static propTypes = {
        additionalPlantIds: PropTypes.array.isRequired,
        plant: PropTypes.object.isRequired,
    }

    render() {
        const { additionalPlantIds, plant } = this.props;

        const additionalPlantJsx = additionalPlantIds.map((plantId, i) => {
            const { name, plantType, rego, make, model, year } = plant[plantId];
            let detailsString = [year, make, model].join(` `).replace(`  `, ` `).trim();

            const haveDetails = detailsString.length > 0;

            // Separate rego and make model year with a hyphen if there is a rego and details
            if (!!rego && haveDetails)
                detailsString = ` - ${detailsString}`;

            const detailsJsx = haveDetails &&
                <p className="details-item">{rego}{detailsString}</p>;

            return (
                <div className="booking-heading-details-item" key={i}>
                    <h2 className="heading-item">{name} ({plantType})</h2>
                    {detailsJsx}
                </div>
            );
        });

        return (
            <div className="booking-additional-plant-item">
                {additionalPlantJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Booking/BookingAdditionalPlantItem.jsx